import { FooterButton, ContentType, PageType } from './types';
import { formatClassName } from '../../utils';
import React from 'react';

interface PageBodyClassNameCfg {
  usePageWrapper?: boolean;
  pageBodyClassName?: string;
  banner?: any;
  toolbar?: React.ReactElement;
  footerButtons?: FooterButton[];
  headerTabs?: React.ReactElement;
  showHeader?: boolean;
}

export const getPageClassName = (pageType: PageType, contentType: ContentType, className?: string) => {
  return formatClassName(['page-template', pageType, contentType, className]);
};

export const getPageBodyClassName = ({
  usePageWrapper,
  pageBodyClassName,
  banner,
  toolbar,
  footerButtons,
  headerTabs,
  showHeader,
}: PageBodyClassNameCfg) => {
  return formatClassName([
    `page-body ${!usePageWrapper ? 'row' : ''}`,
    pageBodyClassName,
    banner,
    toolbar,
    {
      'has-footer': footerButtons,
      'header-tabs': headerTabs,
      'no-header': !showHeader,
    },
  ]);
};
